import React from 'react'
import * as FileSaver from 'file-saver'
import { Workbook } from 'exceljs'
import { useTranslation } from 'react-i18next'
import Button from '../inputs/Button'

export default function ExportToExcelWithColor({
  excelData,
  fileName,
  wscols,
  submissionDeadline
}) {
  const { t } = useTranslation('proposals')
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const fileExtension = '.xlsx'
  const sheetName = !!submissionDeadline
    ? submissionDeadline
        .toDate()
        .toLocaleDateString('fi-FI', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric'
        })
        .toUpperCase()
    : 'data'

  const renderCellValue = value => {
    if (typeof value === 'object' && value !== null) {
      return Object.entries(value)
        .filter(([key, val]) => val !== '')
        .map(
          ([key, val]) =>
            ` ${val === 'plus' ? '+' : val === 'minus' ? '-' : ''}`
        )
        .join(' ')
    }

    return value
  }

  const exportToCSV = async (apiData, fileName) => {
    const workbook = new Workbook()
    const worksheet = workbook.addWorksheet(sheetName)

    worksheet.columns = wscols.map((col, index) => ({
      key: index + 1,
      width: col.wch,
      style: { numFmt: col.numFmt }
    }))

    // Add the headers
    const headers = Object.keys(apiData[0])
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(1, index + 1)
      cell.value = header
    })

    apiData.forEach((row, rowIndex) => {
      const excelRow = worksheet.addRow(row)
      excelRow.height = 25 // Set the height of the row
      Object.entries(row).forEach(([key, value], columnIndex) => {
        const cell = worksheet.getCell(rowIndex + 2, columnIndex + 1)
        if (value.fill) {
          cell.fill = value.fill
        } else {
          cell.value = renderCellValue(value)
        }
      })
    })

    const buffer = await workbook.xlsx.writeBuffer()
    const data = new Blob([buffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  return (
    <Button
      variant="contained"
      color="primary"
      size="md"
      onClick={e => exportToCSV(excelData, fileName)}
    >
      {t('Ratings Excel')}
    </Button>
  )
}
